import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAllFamilies() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/family/families', HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async findFamilies(lastName) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios.get('/family/families/' + lastName, HEADER).then((res) => res.data);
	},

	async getFamily(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/family/${id}?view=web`, HEADER);
				let { Data: data } = res.data;
				if (data.family.documents && data.family.documents.length) {
					data.family.documents = data.family.documents.sort((a, b) => {
						return (
							new Date(b.documentElement.updatedAt) -
							new Date(a.documentElement.updatedAt)
						);
					});
				}
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getFamilySimple(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/family/simple/${id}`, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async postFamily(lastName, userId, children) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.post('/family', { lastName, userId, children }, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putFamily(id, lastName, userId, children) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put(
					'family/' + id,
					{ lastName, userId, children },
					HEADER
				);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putDataFamily(id, params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put('family/data/' + id, params, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putDocumentFamily(id, params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put('family/document/' + id, params, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
